import * as React from "react";
import styled from "styled-components";
import { LinkContainer } from "components/common";
import { Badge, Nav } from "components/bootstrap";
import useCurrentUser from "hooks/useCurrentUser";
import useNotifications from "components/notifications/useNotifications";
import Routes from "routing/Routes";
import { NAV_ITEM_HEIGHT } from "theme/constants";
import InactiveNavItem from "./InactiveNavItem";
const hasNotificationPermission = (permissions) => permissions.some((p) => p === "*" || p === "notifications:*" || p.startsWith("notifications:read"));
const StyledNav = styled(Nav)`
  > li > a {
    min-height: ${NAV_ITEM_HEIGHT};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 12px;
  }
`;
const StyledInactiveNavItem = styled(InactiveNavItem)`
  a:hover {
    border: 0;
    text-decoration: none;
  }
`;
const NotificationBadge = () => {
  const currentUser = useCurrentUser();
  const enabled = hasNotificationPermission(currentUser.permissions);
  const { data, isLoading } = useNotifications({ enabled });
  return isLoading || !data || data.total === 0 ? null : /* @__PURE__ */ React.createElement(StyledNav, { navbar: true }, /* @__PURE__ */ React.createElement(LinkContainer, { to: Routes.SYSTEM.OVERVIEW }, /* @__PURE__ */ React.createElement(StyledInactiveNavItem, null, /* @__PURE__ */ React.createElement(Badge, { bsStyle: "danger", "data-testid": "notification-badge", title: "System Notifications" }, data.total))));
};
export default NotificationBadge;
